import * as React from 'react'
import BaseIcon from 'react-icon-base'

const StoryIcon = props => (
  <BaseIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M4 14h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zm3 2l-4 4v-4.126A4.002 4.002 0 0 1 0 12V4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H7z"
    />
  </BaseIcon>
)

export default StoryIcon
